import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { LocalStorageService } from '../services/local-storage.service';

export const authGuard: CanActivateFn = (_route, _state) => {
  const localStorageService = inject(LocalStorageService);
  const authService = inject(AuthService);
  const router = inject(Router);
  const user = localStorageService.getUser();
  const token = user?.['oss-api-token'];
  if (token) {
    return true;
  }
  authService.resetState();
  router.navigate(['/auth']);
  return false;
};
